import CandidateCustomFields from './CandidateCustomFields';

export default CandidateCustomFields;
